// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IwH9","buttons":"styles_buttons__2fmTT"};